import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VueHtmlToPaper from 'vue-html-to-paper';
import services from "@/services/services.js";
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader


Vue.config.productionTip = false

Vue.use(VueHtmlToPaper);

new Vue({
    router,
    render: h => h(App),
    vuetify,

    beforeCreate() {
        //get settings and init service:
        axios
            //.get('./settings.json')
            .get(process.env.VUE_APP_SETTINGS_URL)
            .then((response) => {
                //todo: check if apiUri can be removed in production - this should be the same as where app is running.
                //if so, settings.json can be removed an during dev get apiUrl from env.development file.
                store.setApiUriAction(response.data.apiUri)
                services.init(response.data.apiUri);
                this.$mount('#app'); //this can be used to mount after settings are loaded.
            });

    }
})//.$mount('#app')